export const APRENDER_ORYA_LIKE_REASONS = [
  {
    code: 'accurate',
    title: 'Preciso',
    description: 'Descreve o produto ou recurso com precisão.',
  },
  {
    code: 'solved',
    title: 'Resolveram meu problema.',
    description: 'Me ajudou a resolver um problema.',
  },
  {
    code: 'easy',
    title: 'Fácil de entender',
    description: 'Fácil de seguir e compreender.',
  },
  {
    code: 'decided',
    title: 'Me ajudou a decidir usar o produto.',
    description: 'Me convenceu a adotar o produto ou recurso.',
  },
  {
    code: 'other',
    title: 'Outro motivo',
    description: '',
  },
];

export const APRENDER_ORYA_DISLIKE_REASONS = [
  {
    code: 'incorrect',
    title: 'Incorreto',
    description: 'Não descreve o produto ou a funcionalidade com precisão.',
  },
  {
    code: 'missing',
    title: 'Não consegui encontrar o que procurava.',
    description: 'Faltam informações importantes.',
  },
  {
    code: 'hard',
    title: 'Difícil de entender',
    description: 'Muito complicado ou confuso.',
  },
  {
    code: 'code_errors',
    title: 'Erros de exemplo de código',
    description: 'Um ou mais exemplos de código estão incorretos.',
  },
  {
    code: 'other',
    title: 'Outro motivo',
    description: '',
  },
];
